<template>
<div class="payment-success">
	<div class="success-card">
        <h1 v-if="$route.params.is_trial">Promo Activated <i class="icon icon-check"></i></h1>
		<h1 v-else>Payment Success <i class="icon icon-check"></i></h1>
		<div class="download-line">
			<div class="product-name">
				<h2>
					{{productName}}
				</h2>
				<small>Version {{version}}</small>
			</div>
			<a :class="{'active':isWindows}" :href="'/sos/download/sos.msi'" download ref="windows"><i class="icon icon-brand-microsoft"></i><span>Windows</span></a>

			<a @click="macDownloadClick" id="macButton" :class="{'active':isMac}"><i class="icon icon-brand-apple"></i> Mac</a>
	        <Popper ref="macDownloads" :target_id="'macButton'" :placement="'bottom-start'" :append_to_body="true" :offset="[0,2]">
	        	<div class="dropdown-menu mac-downloads">
	         		<a :href="'/sos/download/arm/sos.dmg?fingerprint='+fingerprint" download><i class="icon icon-download"></i> Apple Silicon </a>
	           		<a :href="'/sos/download/sos.dmg?fingerprint='+fingerprint" download><i class="icon icon-download"></i> Intel </a>
	        	</div>
	        </Popper>
		</div>



		<h2>Activation Code</h2>
		<div class="license-code">
        	<p>{{$route.params.key}}</p>
         	<span @click="copyToClipboard"><i class="icon icon-copy"></i> Copy</span>
		</div>
	</div>

	<div class="info">
		<ol>
            <li>Download the software</li>
            <li>Paste the activation code into your SOS List instance</li>
			<li v-if="!$route.params.is_trial">A copy of your invoice has been sent to your email</li>
		</ol>
	</div>

</div>
</template>

<script>
import GeneralContainer from "@/components/base/GeneralContainer";
import Platform from "platform";
import Popper from "@/../submodules/vue-base/components/Popper";

import store from "@/store";
import {
    mapGetters
} from 'vuex';

export default {

    name: "PaymentConfirm",

    components: {
        GeneralContainer,
        Popper,
    },

    beforeRouteEnter(to,from,next){
		store.dispatch("loadLicenseInfo",to.params.key).then(function(response){
			console.log(response)
			next();
		}).catch(function () { next(); })

    },

    data() {
        return {
            isMac: false,
            isWindows: false,
            isMobile: false,
        }
    },

    created(){
   		this.isMac = Platform.os.family.includes("OS X");
     	this.isWindows = Platform.os.family.includes("Windows");
    },

    methods: {
   		macDownloadClick(){
			this.$refs.macDownloads.toggle();
    	},
        copyToClipboard() {
            // Create a "hidden" input
            var aux = document.createElement("input");

            // Assign it the value of the specified element
            aux.setAttribute("value", this.$route.params.key);

            // Append it to the body
            document.body.appendChild(aux);

            // Highlight its content
            aux.select();

            // Copy the highlighted text
            document.execCommand("copy");

            // Remove it from the body
            document.body.removeChild(aux);

            var toastInstance = this.$toasted.show('License Code Copied', {
                duration: "3000",
                className: "toast-success",
                position: "top-center"
            });
        },
    },

    computed: {
    	productName(){
			var result = "SOS List";
	    	if(this.licenseInfo){
				if(this.licenseInfo.product_name&&this.licenseInfo.product_name!=''){
					result = this.licenseInfo.product_name;
				}
			}
			return result;
	    },
		version(){
			var result = "3.0.0";
	    	if(this.licenseInfo){
				if(this.licenseInfo.version&&this.licenseInfo.version!=''){
					result = this.licenseInfo.version;
				}
			}
			return result;
	    },
    	...mapGetters(["licenseInfo"])
    }

}
</script>

<style lang="less" scoped>
@import (reference) "@/assets/less/style.less";

.callout {
    margin-bottom: 2em;
}

h2 {
    font-weight: 400;
}

button {
    margin-bottom: 1.5em;
}

@media @breakpoint-xl-up {
    .code {
        margin: 1em 0;
        font-size: 1.5em;
        font-weight: 500;
    }
}
</style>
